import React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import AdminOrganizationsAccessesPage from "./Accesses";
import AdminOrganizationsEditPage from "./Edit";
import AdminOrganizationsIndexPage from "./Index/index";
import AdminOrganizationsPartnerPage from "./Partner";
import AdminOrganizationsPreviewPage from "./Preview";
import AdminOrganizationProductsPage from "./Products";

const AdminOrganizationsPage = (props: RouteComponentProps) => {
	return (
		<Switch>
			<Route path={`${props.match.url}/`} exact component={AdminOrganizationsIndexPage} />
			<Route path={`${props.match.url}/:organizationId/edit`} component={AdminOrganizationsEditPage} />
			<Route path={`${props.match.url}/:organizationId/partner`} component={AdminOrganizationsPartnerPage} />
			<Route path={`${props.match.url}/:organizationId/accesses`} component={AdminOrganizationsAccessesPage} />
			<Route
				path={`${props.match.url}/:organizationId/edit_products`}
				component={AdminOrganizationProductsPage}
			/>
			<Route path={`${props.match.url}/:organizationId`} component={AdminOrganizationsPreviewPage} />
		</Switch>
	);
};

export default AdminOrganizationsPage;
